var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 178,
    viewBox: "0 0 167 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_7057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.53 22.7614C82.2113 24.9561 79.2504 28.5232 76.979 32.6978C73.7441 38.6455 73.9817 44.5566 77.6266 50.2162C81.846 56.7637 89.6866 56.8163 94.1305 50.4443C96.5143 47.0393 97.2507 43.1895 97.1514 39.109C97.0576 37.4069 97.0157 35.7045 96.8538 34.0021C96.5798 31.1212 96.1647 28.2403 94.8724 25.6213C93.6502 23.1202 91.9741 21.8473 89.8904 21.8473C88.7145 21.8838 87.5633 22.1969 86.53 22.7614Z",
    fill: "url(#paint0_linear_621_7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.722 24.9794C105.122 26.0826 104.663 27.2574 104.356 28.4757C103.39 32.1423 103.262 35.9006 103.139 39.2583C103.121 44.6402 104.252 48.1626 106.886 51.4078C110.67 56.0484 116.589 56.4389 120.907 52.3165C122.518 50.7793 123.576 48.9119 124.333 46.8167C125.761 42.8304 125.975 38.9072 124.351 34.9342C122.834 31.2445 120.493 27.9535 117.508 25.3146C116.159 24.0497 114.583 23.051 112.865 22.3709C112.074 22.0543 111.232 21.884 110.38 21.868C108.448 21.868 106.881 22.9156 105.722 24.9872",
    fill: "url(#paint1_linear_621_7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.301 63.0693C86.4969 64.2452 85.7787 65.4816 84.9877 66.6706C83.4916 68.91 81.5932 70.8059 79.7238 72.7153C77.4338 74.4937 75.2719 76.3819 73.7183 78.8986C73.3607 79.4748 73.3818 79.6843 74.0709 79.8832C75.6375 80.3182 77.2042 80.8314 78.7552 81.3109C87.3923 83.9637 96.1574 86.1377 104.886 88.4475C110.776 90.0058 115.988 92.7323 119.275 98.2164C119.505 98.5989 119.748 98.6617 120.126 98.4781C120.999 98.046 121.923 97.6927 122.737 97.1924C127.098 94.4764 129.406 90.5897 128.887 85.3859C128.443 80.9335 126.106 77.4399 122.743 74.5929C122.266 74.0397 121.704 73.566 121.079 73.1893C118.088 71.123 115.691 68.303 114.132 65.0127C112.931 62.5624 111.111 60.4702 108.854 58.9447C106.597 57.4188 103.981 56.513 101.266 56.317C98.5508 56.1207 95.8318 56.6415 93.3799 57.8272C90.9281 59.0129 88.8287 60.822 87.2904 63.0748",
    fill: "url(#paint2_linear_621_7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.716 46.3295C129.916 46.7517 129.18 47.2871 128.531 47.9192C125.21 51.1851 123.014 55.1558 121.426 59.4771C120.319 62.4748 120.259 65.7615 121.257 68.7979C122.596 73.0434 126.719 75.4006 131.066 74.4261C134.484 73.6616 136.769 71.3332 138.735 68.7012C140.639 66.163 141.556 63.016 141.314 59.849C141.397 58.2808 141.243 56.709 140.857 55.1872C140.132 52.1282 139.03 49.2524 136.662 47.0681C135.617 46.1018 134.489 45.6226 133.301 45.6226C132.395 45.6408 131.507 45.8839 130.716 46.3295Z",
    fill: "url(#paint3_linear_621_7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5544 0.856675C84.9699 1.61549 77.5753 3.69467 70.7029 7.00083C67.2486 8.64295 64.0265 10.7329 60.4911 12.2388C53.3581 15.2586 45.9454 17.3354 38.3893 18.9251C26.9529 21.3294 15.3784 22.7017 3.72025 23.3774L0.124893 23.5974C0.553096 23.7965 0.699314 23.8803 0.858586 23.9353C7.91897 26.4023 15.2893 27.8639 22.7545 28.2776C33.1228 28.8852 43.3552 27.8009 53.4626 25.4255C61.6063 23.5136 69.4625 20.7506 77.1129 17.3982C87.194 12.98 97.6433 11.5448 108.482 13.4698C124.448 16.2904 136.644 24.7969 145.38 38.4079C147.283 41.3753 148.686 44.5993 150.08 47.8364C152.673 55.2401 153.879 62.8405 153.263 70.6949C153.138 72.2846 152.963 73.8718 152.809 75.4589C152.087 79.4449 151.012 83.3583 149.597 87.1526C149.433 87.4931 149.252 87.8281 149.101 88.1767C144.064 99.7368 136.007 108.524 125.012 114.628C124.348 114.998 124.124 114.927 123.853 114.223C122.681 111.197 121.12 108.337 119.21 105.716C115.16 100.127 110.072 95.9552 103.218 94.3969C99.8234 93.6294 96.403 93.0611 93.0477 92.1732C83.81 89.727 74.2801 88.1478 65.9119 83.0619C64.6348 82.2762 63.4182 82.7999 62.6166 84.0779C61.8646 85.275 62.1753 86.422 62.7105 87.5559C63.7758 89.8109 65.452 91.5787 67.3137 93.1735C72.0137 97.1989 77.476 99.9649 83.0816 102.466C83.5229 102.662 83.9981 102.806 84.3481 103.171C84.562 103.393 84.8465 103.605 84.7814 103.956C84.7163 104.307 84.327 104.365 84.0374 104.407C83.5928 104.485 83.1405 104.511 82.6901 104.485C81.0277 104.36 79.3756 104.123 77.7449 103.775C71.2173 102.283 65.4418 99.2601 60.1204 95.2793C55.178 91.5813 50.9586 87.1607 47.1071 82.3572C44.0705 78.6198 41.102 74.825 38.4075 70.8336C38.1018 70.2916 37.8017 69.7468 37.4859 69.2074C36.4569 67.4684 35.4779 65.7031 34.8538 63.7675C34.6737 63.2124 34.4779 62.6022 33.8277 62.6259C33.1306 62.6493 33.0758 63.3408 32.9817 63.8828C32.5953 66.1484 32.9348 68.3903 33.2194 70.6347C33.2637 71.1113 33.3212 71.5879 33.3525 72.0646C33.5548 75.4013 34.0697 78.7114 34.8904 81.9514C35.8142 86.2049 37.2021 90.3434 39.0289 94.2921C51.802 122.368 82.0112 137.998 112.181 131.938C130.704 128.211 145.048 118.138 155.326 102.267C158.095 98.0412 160.283 93.4604 161.832 88.6482C163.344 84.7195 164.232 80.647 164.835 76.4987C166.216 66.9312 165.618 57.5031 162.837 48.2316C162.595 47.1101 162.262 46.0102 161.843 44.9423C156.106 28.9375 145.819 16.7671 130.991 8.57748C121.406 3.23861 110.615 0.457501 99.651 0.500491C97.3115 0.500491 94.9462 0.619219 92.5544 0.856675Z",
    fill: "url(#paint4_linear_621_7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3605 48.4305C60.0603 51.5183 59.1227 55.1116 58.9295 58.9067C58.8069 61.2792 58.9295 63.6419 60.0316 65.8338C61.1606 68.8107 63.2293 71.3354 65.9221 73.0229C68.084 74.4006 70.4311 74.9794 72.9717 74.4714C76.3659 73.7904 78.8178 70.7132 79.4993 66.6509C79.8376 65.3678 79.8769 64.0233 79.6139 62.7226C78.5358 56.7721 75.6819 51.7227 71.3501 47.5794C69.9377 46.228 68.4936 45.5653 67.0969 45.5653C65.3996 45.5653 63.7733 46.5423 62.3554 48.4462",
    fill: "url(#paint5_linear_621_7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1315 176.278V133.909H65.6805L63.6543 141.422H45.3585V151.213H61.1373L59.1726 158.665H45.3585V176.278H37.1315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0565 151.213C75.408 151.213 72.4613 155.647 72.4613 160.759C72.4613 165.87 75.408 170.366 81.0565 170.366C86.7047 170.366 89.6517 165.87 89.6517 160.759C89.6517 155.647 86.7047 151.213 81.0565 151.213ZM81.0565 144.316C91.4938 144.316 97.6331 151.522 97.6331 160.759C97.6331 170.058 91.4938 177.263 81.0565 177.263C70.6192 177.263 64.4798 170.058 64.4798 160.759C64.4798 151.522 70.6192 144.316 81.0565 144.316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.875 157.926C121.875 154.293 120.156 151.829 116.472 151.829C112.665 151.829 110.455 154.293 110.455 158.85V176.278H102.535V145.301H110.209L110.271 150.351C111.929 146.841 115.183 144.747 119.48 144.747C125.927 144.747 129.795 149.181 129.795 155.894V176.278H121.875V157.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.598 151.46C145.196 151.46 142.31 155.647 142.31 160.759C142.31 165.87 145.196 170.119 150.598 170.119C156.001 170.119 158.825 165.87 158.825 160.759C158.825 155.647 156.001 151.46 150.598 151.46ZM159.009 170.489C157.29 174.307 153.545 176.955 148.45 176.955C139.793 176.955 134.329 169.935 134.329 160.759C134.329 151.644 139.793 144.624 148.573 144.624C153.361 144.624 157.045 147.026 158.825 150.597V132.061H166.745V176.278H159.071L159.009 170.489Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_7057",
    x1: 112.614,
    y1: -0.181032,
    x2: 43.5209,
    y2: 105.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0A70F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2436E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_7057",
    x1: 130.941,
    y1: 11.7927,
    x2: 61.8483,
    y2: 117.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0A70F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2436E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_7057",
    x1: 143.351,
    y1: 19.9057,
    x2: 74.2584,
    y2: 125.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0A70F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2436E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_7057",
    x1: 153.795,
    y1: 26.7264,
    x2: 84.7019,
    y2: 132.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0A70F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2436E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_621_7057",
    x1: 116.899,
    y1: 2.61926,
    x2: 47.8065,
    y2: 108.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0A70F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2436E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_621_7057",
    x1: 110.077,
    y1: -1.83842,
    x2: 40.9835,
    y2: 103.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0A70F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2436E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_7057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 177,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8476912ba0d33d4845c9618358805ebe.svg";
export { ForwardRef as ReactComponent };